import { useJournalClassStore } from "@/stores/models/journal";

export default async function journalClassExists({ to }) {
    let exists = false;
    let cId = to.params.classId;
    if (cId) {
        try {
            const store = useJournalClassStore();
            let existing = store.item(cId);
            if (!existing) {
                await store.fetchItem({
                    query: { id: cId },
                    key: "VIEW_CLASS"
                });
            }

            exists = true;
        } catch (err) {
            exists = false;
        }
    }

    if (!exists) {
        return {
            name: "Not Found"
        };
    }
}
